<template>
  <div class="ForumResponseProfile" :class="{ 'ForumResponseProfile--sm': small }">
    <div class="ForumResponseProfile__common">
      <div v-if="isOwnerVisible" class="ForumResponseProfile__user-name">
        {{ name }}
      </div>
      <div v-else-if="isOwnerHidden" class="ForumResponseProfile__anonymous-name">
        <template v-if="anonymousId">
          {{ $t('forum.response.anonymous_reply_user_name_with_id', { id: anonymousId }) }}
        </template>
        <template v-else>{{ $t('forum.response.anonymous_reply_user_name') }}</template>
      </div>
      <div v-else-if="isOwnerModerator" class="ForumResponseProfile__moderator-name">
        <template v-if="anonymousId">
          {{ $t('forum.response.moderator_reply_user_name_with_id', { id: anonymousId }) }}
        </template>
        <template v-else>
          {{ $t('forum.response.moderator_reply_user_name') }}
        </template>
      </div>
    </div>

    <div v-if="isNoticeVisible" class="ForumResponseProfile__notice">
      <template v-if="isAnonymousNoticeVIsible">
        {{ $t('forum.response.anonymous_reply_label') }}
      </template>
    </div>
  </div>
</template>

<script>
import { ForumResponseModel } from '@/models/forum/forumResponse'

export default {
  name: 'ForumResponseProfile',
  props: {
    response: { type: ForumResponseModel, default: null },
    small: { type: Boolean, default: false },
    hideNotice: { type: Boolean, default: false }
  },
  computed: {
    anonymousReplyLetter() {
      return this.$t('forum.response.anonymous_reply_user_name').slice(0, 1)
    },
    isNoticeVisible() {
      return (this.isAnonymousNoticeVIsible || this.isModeratorNoticeVIsible) && !this.hideNotice
    },
    isModeratorNoticeVIsible() {
      return this.response.anonymousState && this.response.user
    },
    isAnonymousNoticeVIsible() {
      return this.response.anonymousState && this.response.prospect
    },
    anonymousId() {
      return this.response?.anonymousId
    },
    isOwnerVisible() {
      return !this.isOwnerHidden && !this.isOwnerModerator
    },
    isOwnerHidden() {
      return (
        this.response.anonymousState &&
        this.response.prospect?.id !== this.$store.getters['user/user']?.id &&
        !this.response.isOwnerModerator
      )
    },
    isOwnerModerator() {
      return (
        this.response.anonymousState &&
        this.response.prospect?.id !== this.$store.getters['user/user']?.id &&
        this.response.isOwnerModerator
      )
    },
    prospect() {
      return this.response?.prospect
    },
    user() {
      return this.response?.user
    },
    name() {
      return (
        (this.response?.prospect
          ? this.response?.prospect?.fullNameWithShortLastName
          : this.response?.user?.fullNameWithShortLastName) || this.$t('not-available')
      )
    }
  }
}
</script>

<style scoped lang="scss">
.ForumResponseProfile {
  $root: &;
  @apply flex items-center;

  &__common {
    @apply text-body-02 min-w-0;
  }
  &__user-name,
  &__anonymous-name {
    @apply text-primary-01-400 truncate;
  }
  &__moderator-name {
    @apply text-accent-01 truncate;
  }
  &__notice {
    @apply text-neutral-01-400 text-xs italic ml-1 flex-shrink-0;
  }

  &.ForumResponseProfile--sm {
    #{$root}__common {
      @apply text-body-02;
    }
    #{$root}__notice {
      @apply text-caption-02;
    }
  }
}
</style>
